export const toInches = meters => (meters ? (meters * 39.3701).toFixed(2) : undefined);

export const toMeters = inches => (inches ? (inches / 39.3701).toFixed(2) : undefined);
